import { render, staticRenderFns } from "./OperaShopWindow.vue?vue&type=template&id=af1646f4&scoped=true&"
import script from "./OperaShopWindow.vue?vue&type=script&lang=js&"
export * from "./OperaShopWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaShopWindow.vue?vue&type=style&index=0&id=af1646f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1646f4",
  null
  
)

export default component.exports